import script from "./popupRender.vue?vue&type=script&lang=js"
export * from "./popupRender.vue?vue&type=script&lang=js"

import "./popupRender.vue?vue&type=style&index=0&id=d0c8782a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d0c8782a"]])

export default __exports__